export default __webpack_public_path__ + "fonts/SuisseIntl-Regular-WebXL.woff";